 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","agenda~cita~orden":"agenda~cita~orden","agenda":"agenda","cita":"cita","orden~ordenes":"orden~ordenes","catalogoequipo~orden":"catalogoequipo~orden","orden":"orden","catalogobranding":"catalogobranding","catalogobrandings":"catalogobrandings","catalogocliente":"catalogocliente","catalogoclientes":"catalogoclientes","catalogoequipos":"catalogoequipos","catalogoequipo":"catalogoequipo","catalogoimportar":"catalogoimportar","catalogousuario":"catalogousuario","catalogousuarios":"catalogousuarios","empresa":"empresa","inventario":"inventario","login":"login","ordenes":"ordenes","reportes":"reportes"}[chunkId]||chunkId) + "." + {"about":"bb2261e5","agenda~cita~orden":"8a6357fe","agenda":"aa6c328b","cita":"362143e9","orden~ordenes":"6117ba55","catalogoequipo~orden":"eaf901c9","orden":"26c9511a","catalogobranding":"07da708f","catalogobrandings":"51ca38d2","catalogocliente":"ad566b42","catalogoclientes":"55d1c71c","catalogoequipos":"17f518af","catalogoequipo":"ce87431c","catalogoimportar":"2a449d25","catalogousuario":"1bde9a21","catalogousuarios":"ae06b40e","chunk-0471966a":"a8a7a7b9","chunk-0867d75f":"cdcff368","chunk-09cd0b70":"c064c938","chunk-0a1eaca9":"40831a92","chunk-0e072455":"785663d5","chunk-0ffeab9f":"05e14a4b","chunk-198e3942":"37192e7e","chunk-1f16206c":"372b8a7b","chunk-245db3ed":"fd333bbe","chunk-268044d4":"095d71a4","chunk-28a9e288":"910976c2","chunk-29757256":"3d010ed1","chunk-2a9b8bee":"11a457fd","chunk-2aed0630":"90c6e44d","chunk-2d0aa1e4":"ff81713f","chunk-2d0b9671":"e9de491c","chunk-2d0bdd44":"31936f5e","chunk-2d0be327":"6ae6e7fc","chunk-2d0c0883":"3b8df9dd","chunk-2d0df486":"1e4e7c48","chunk-2d0e1b06":"be2de246","chunk-2d0f060d":"e54a7b3f","chunk-2d0f0814":"c9791cdc","chunk-2d0f14f4":"63b18db7","chunk-2d2095dd":"a4050f66","chunk-2d20fcba":"c16ae8fd","chunk-2d213925":"cd323c9c","chunk-2d218418":"9143c193","chunk-2d21d14c":"15b8c744","chunk-2d21e3aa":"7d320c61","chunk-2d222525":"857d844e","chunk-2d228cf2":"e7c0b6e8","chunk-2d22e146":"c82a61e6","chunk-2d2304b6":"13628160","chunk-3172533a":"d8475f4d","chunk-32cdbffc":"6a05c638","chunk-3609acea":"8153ae45","chunk-36da2acc":"fb26c53f","chunk-37ff8997":"5f869c2f","chunk-3b7db6f5":"02206e60","chunk-3bd70db3":"81aeedff","chunk-3ee4eca5":"caccda87","chunk-41729f35":"3cc625a8","chunk-41c90a6b":"43914ff8","chunk-45636d0e":"b5da5ac3","chunk-45df0daa":"0a71644c","chunk-469a106c":"3eeb664a","chunk-4960e528":"a002f56d","chunk-4a868a77":"9f837663","chunk-4d93dcb2":"f696bbe5","chunk-4da36b15":"3d495dd2","chunk-4f3678b7":"0bc379a2","chunk-55fd9bc5":"9454eb9c","chunk-57598eed":"738a25cb","chunk-57a83ac0":"de0e976d","chunk-58018476":"be60ce11","chunk-5b23fdd4":"c09979aa","chunk-6435f914":"f0764412","chunk-658c23da":"c4eca808","chunk-6a5dbffb":"dd1a99bd","chunk-6ae2b080":"77348c4a","chunk-6d44dfd7":"0d6a5042","chunk-6d941db0":"ed723736","chunk-6da41528":"26457bde","chunk-6da41684":"bf95d334","chunk-793ec3d8":"f53388b0","chunk-7a234d26":"26ed92f6","chunk-7d21e4da":"4e83c417","chunk-882768b0":"5ab1b5fb","chunk-972e2b1c":"7be6a078","chunk-9f295fda":"b4161551","chunk-a92a499c":"337a857a","chunk-a92d751a":"48306601","chunk-a9543e8c":"b26bbe03","chunk-a9591d90":"61a788fc","chunk-ae124cc0":"af090082","chunk-bd819d48":"aa5bf09e","chunk-c377db64":"92dc878c","chunk-d6be8784":"c832d970","chunk-dada39de":"9d5ba66a","chunk-dae3f45e":"4288783d","chunk-dd32cf7c":"f29e140b","chunk-de1eb938":"ab1a9a44","chunk-dffd094a":"65d8914e","chunk-ea2d3954":"9d5a12bb","chunk-efc7162e":"e97dda82","chunk-f71781cc":"fe3fa14a","chunk-f8c074fc":"2090ce79","empresa":"60f46b71","inventario":"b5c10e7c","login":"efc58727","ordenes":"717d6dda","reportes":"c8dd5fca","chunk-2d0c4a65":"45790aaa","chunk-2d21f28e":"c17c3517","chunk-2d22dbb6":"2495e615","chunk-2d0da519":"a87d80f0","chunk-2d0a4d7c":"252c133c","chunk-2d0cc79b":"2ac1afcd","chunk-2d0d0f6c":"97ef27fd","chunk-2d224c4a":"9835072f","chunk-2d230089":"06d3f17a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"agenda":1,"cita":1,"orden":1,"catalogoequipos":1,"catalogoimportar":1,"ordenes":1,"reportes":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","agenda~cita~orden":"agenda~cita~orden","agenda":"agenda","cita":"cita","orden~ordenes":"orden~ordenes","catalogoequipo~orden":"catalogoequipo~orden","orden":"orden","catalogobranding":"catalogobranding","catalogobrandings":"catalogobrandings","catalogocliente":"catalogocliente","catalogoclientes":"catalogoclientes","catalogoequipos":"catalogoequipos","catalogoequipo":"catalogoequipo","catalogoimportar":"catalogoimportar","catalogousuario":"catalogousuario","catalogousuarios":"catalogousuarios","empresa":"empresa","inventario":"inventario","login":"login","ordenes":"ordenes","reportes":"reportes"}[chunkId]||chunkId) + "." + {"about":"31d6cfe0","agenda~cita~orden":"31d6cfe0","agenda":"24c8cd13","cita":"8a80519a","orden~ordenes":"31d6cfe0","catalogoequipo~orden":"31d6cfe0","orden":"ceecf1be","catalogobranding":"31d6cfe0","catalogobrandings":"31d6cfe0","catalogocliente":"31d6cfe0","catalogoclientes":"31d6cfe0","catalogoequipos":"7ed6c178","catalogoequipo":"31d6cfe0","catalogoimportar":"5d887f7c","catalogousuario":"31d6cfe0","catalogousuarios":"31d6cfe0","chunk-0471966a":"31d6cfe0","chunk-0867d75f":"31d6cfe0","chunk-09cd0b70":"31d6cfe0","chunk-0a1eaca9":"31d6cfe0","chunk-0e072455":"31d6cfe0","chunk-0ffeab9f":"31d6cfe0","chunk-198e3942":"31d6cfe0","chunk-1f16206c":"31d6cfe0","chunk-245db3ed":"31d6cfe0","chunk-268044d4":"31d6cfe0","chunk-28a9e288":"31d6cfe0","chunk-29757256":"31d6cfe0","chunk-2a9b8bee":"31d6cfe0","chunk-2aed0630":"31d6cfe0","chunk-2d0aa1e4":"31d6cfe0","chunk-2d0b9671":"31d6cfe0","chunk-2d0bdd44":"31d6cfe0","chunk-2d0be327":"31d6cfe0","chunk-2d0c0883":"31d6cfe0","chunk-2d0df486":"31d6cfe0","chunk-2d0e1b06":"31d6cfe0","chunk-2d0f060d":"31d6cfe0","chunk-2d0f0814":"31d6cfe0","chunk-2d0f14f4":"31d6cfe0","chunk-2d2095dd":"31d6cfe0","chunk-2d20fcba":"31d6cfe0","chunk-2d213925":"31d6cfe0","chunk-2d218418":"31d6cfe0","chunk-2d21d14c":"31d6cfe0","chunk-2d21e3aa":"31d6cfe0","chunk-2d222525":"31d6cfe0","chunk-2d228cf2":"31d6cfe0","chunk-2d22e146":"31d6cfe0","chunk-2d2304b6":"31d6cfe0","chunk-3172533a":"31d6cfe0","chunk-32cdbffc":"31d6cfe0","chunk-3609acea":"31d6cfe0","chunk-36da2acc":"31d6cfe0","chunk-37ff8997":"31d6cfe0","chunk-3b7db6f5":"31d6cfe0","chunk-3bd70db3":"31d6cfe0","chunk-3ee4eca5":"31d6cfe0","chunk-41729f35":"31d6cfe0","chunk-41c90a6b":"31d6cfe0","chunk-45636d0e":"31d6cfe0","chunk-45df0daa":"31d6cfe0","chunk-469a106c":"31d6cfe0","chunk-4960e528":"31d6cfe0","chunk-4a868a77":"31d6cfe0","chunk-4d93dcb2":"31d6cfe0","chunk-4da36b15":"31d6cfe0","chunk-4f3678b7":"31d6cfe0","chunk-55fd9bc5":"31d6cfe0","chunk-57598eed":"31d6cfe0","chunk-57a83ac0":"31d6cfe0","chunk-58018476":"31d6cfe0","chunk-5b23fdd4":"31d6cfe0","chunk-6435f914":"31d6cfe0","chunk-658c23da":"31d6cfe0","chunk-6a5dbffb":"31d6cfe0","chunk-6ae2b080":"31d6cfe0","chunk-6d44dfd7":"31d6cfe0","chunk-6d941db0":"31d6cfe0","chunk-6da41528":"31d6cfe0","chunk-6da41684":"31d6cfe0","chunk-793ec3d8":"31d6cfe0","chunk-7a234d26":"31d6cfe0","chunk-7d21e4da":"31d6cfe0","chunk-882768b0":"31d6cfe0","chunk-972e2b1c":"31d6cfe0","chunk-9f295fda":"31d6cfe0","chunk-a92a499c":"31d6cfe0","chunk-a92d751a":"31d6cfe0","chunk-a9543e8c":"31d6cfe0","chunk-a9591d90":"31d6cfe0","chunk-ae124cc0":"31d6cfe0","chunk-bd819d48":"31d6cfe0","chunk-c377db64":"31d6cfe0","chunk-d6be8784":"31d6cfe0","chunk-dada39de":"31d6cfe0","chunk-dae3f45e":"31d6cfe0","chunk-dd32cf7c":"31d6cfe0","chunk-de1eb938":"31d6cfe0","chunk-dffd094a":"31d6cfe0","chunk-ea2d3954":"31d6cfe0","chunk-efc7162e":"31d6cfe0","chunk-f71781cc":"31d6cfe0","chunk-f8c074fc":"31d6cfe0","empresa":"31d6cfe0","inventario":"31d6cfe0","login":"31d6cfe0","ordenes":"ef76bca0","reportes":"1aeca5c3","chunk-2d0c4a65":"31d6cfe0","chunk-2d21f28e":"31d6cfe0","chunk-2d22dbb6":"31d6cfe0","chunk-2d0da519":"31d6cfe0","chunk-2d0a4d7c":"31d6cfe0","chunk-2d0cc79b":"31d6cfe0","chunk-2d0d0f6c":"31d6cfe0","chunk-2d224c4a":"31d6cfe0","chunk-2d230089":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
